import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import {
  DOCUMENTS_FEATURE_KEY,
  initialState as documentsInitialState,
  documentsReducer
} from './+state/documents.reducer';
import { DocumentsEffects } from './+state/documents.effects';
import { DocumentsFacade } from './+state/documents.facade';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(DOCUMENTS_FEATURE_KEY, documentsReducer),
    EffectsModule.forFeature([DocumentsEffects])
  ],
  providers: [DocumentsFacade]
})
export class BackOfficeBurialSocietiesDocumentsDataAccessDocumentsModule {}
